//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { TILES_CUSTOMIZE } from '@/scripts/constants/tracker'
import PLP from '@/scripts/libs/plp'
export default {
  name: 'product-tile-footer',
  inject: ['isProductTileEditorial', 'isLoading', 'isPlpExclusive', 'getIsTileFocused'],
  props: {
    selectedIndex: {
      type: Number,
      default: 0,
    },
    colors: {
      type: Array,
      default: () => [],
    },
    selectedVariant: {
      type: Object,
      default: () => ({}),
    },
    isAddToCart: {
      type: Boolean,
      default: false,
    },
    addToBagDataElementId: {
      type: String,
      default: '',
    },
  },
  computed: {
    isExplodedTile() {
      return PLP.getIsPlpTilesExploded()
    },
    hasColorsEditorial() {
      return this.colors.length > 0 && !this.isProductTileEditorial
    },
    customizeIconTabIndex() {
      return this.isTileFocused ? '0' : '-1'
    },
    colorsNumberLabel() {
      const colorTranslation =
        this.colors.length > 1
          ? this.$t('common.product_tile.colors')
          : this.$t('common.product_tile.color')
      const colorsLabel = `${this.colors.length}  ${colorTranslation}`

      if (this.isProductTileEditorial || this.colors.length <= 1) {
        return colorsLabel
      }

      return `${this.selectedIndex + 1} / ${colorsLabel}`
    },
    dataDescriptionCustomize() {
      return `${this.selectedVariant.name}_${this.selectedVariant.partNumber}`
    },
    isTileFocused() {
      return this.getIsTileFocused()
    },
    TILES_CUSTOMIZE() {
      return TILES_CUSTOMIZE
    },
  },
  methods: {
    addToBag() {
      this.$emit('action:add-to-bag', this.selectedVariant)
    },
  },
}
